module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kk-La.0d947767.png";